module.exports = __webpack_public_path__ + "img/deuterium-energy-fuel.6e6be05b.png";